/** Strings owned by `src/manage/support/` — "Beheer › Support" (PLAN-FASE3.md
 * WP-01): the platform-staff-only ticket list and thread view. */
export const manageSupport = {
  page: {
    title: 'Support',
    lead: 'Every support ticket on the platform, filterable by status and priority.',
    filterStatus: 'Status',
    filterPriority: 'Priority',
    allStatuses: 'All statuses',
    allPriorities: 'All priorities',
    empty: 'No tickets match these filters.',
    rowsLabel: 'the tickets',
    subject: 'Subject',
    company: 'Company',
    status: 'Status',
    priority: 'Priority',
    createdAt: 'Opened',
  },
  status: {
    open: 'Open',
    in_progress: 'In progress',
    resolved: 'Resolved',
    closed: 'Closed',
  },
  priority: {
    low: 'Low',
    normal: 'Normal',
    high: 'High',
    urgent: 'Urgent',
  },
  detail: {
    thisTicket: 'this ticket',
    requesterTitle: 'Requester',
    requesterLabel: 'the requester',
    controlsTitle: 'Status & priority',
    save: 'Save',
    threadTitle: 'Conversation',
    threadEmpty: 'No messages yet.',
    replyLabel: 'Reply',
    reply: 'Send reply',
  },
} as const;
